import {useState, useEffect} from 'react'

import './backhand_style.css';
import './backhand_media-queries.css';

import h_1 from './assets_2/h_1.png';
import menu1 from './assets_2/menu1.jpg';
import u_3 from './assets_2/u_3.png';


import { useDisconnect, useAccount } from 'wagmi';

import { Address_ID_Detail, Copy, Sub_Variable } from "./Data_Structure";

import { DashBoard_Form, Roi_Income_Form, Refferal_Income_Form, Team_Tree_Form } from "./Data_Structure";

import { GetTimestamp, GetDateTime } from "./Data_Structure";


let url = "https://fxcprofit.pro/";
// let url = "http://localhost:3000/";


export default function BnbPro_After_Login(props) {
    const {address} = useAccount();

    const { disconnect } = useDisconnect();
    
    const [Is_State_Change, SetIs_State_Change] = useState(true);

    const [ID_, SetID_] = useState("");
    const [ID_Type_, SetID_Type_] = useState(false);
    const [ID_UserName, SetID_UserName] = useState("");
    const [ID_Cur_Topup, SetID_Cur_Topup] = useState(Number(0));

    const [Current_DT, SetCurrent_DT] = useState("");
    
    const Ref_Link = url + "r/" + ID_;

    const Load_Main_Data = () => {
        try {
            Address_ID_Detail(address, SetID_, SetID_Type_, SetID_Cur_Topup, SetID_UserName);
            console.log(ID_Type_);
        }
        catch(error) {
            console.log(error);
        }
    }

    const ReLoad = () => {
        if(Is_State_Change === true) {
            SetIs_State_Change(false);
        }
        else if(Is_State_Change === false) {
            SetIs_State_Change(true);
        }
    }
    
    // useEffect(() => {
    //     const Load = async() => {
    //         try {
    //             SetCurrent_DT(await GetDateTime(await GetTimestamp()));
    //         }
    //         catch(error) {
    //             console.log(error);
    //         }
    //     }
    //     Load();
    // }, [ID_]);

    // useEffect(() => {
    //     const Load = async() => {
    //         try {
    //             await Load_Main_Data();
    //         }
    //         catch(error) {
    //             console.log(error);
    //         }
    //     }
    //     Load();

    // }, [address]);

    useEffect(() => {
        const Load = async() => {
            try {
                SetCurrent_DT(await GetDateTime(await GetTimestamp()));
                await Load_Main_Data();
            }
            catch(error) {
                console.log(error);
            }
        }
        Load();
    }, [Is_State_Change])

    return (
        <>
            <div class="main-content">
                <header>
                    <div class="sidebar-brand">
                        <span>FXC PROFIT</span>
                    </div>
                    <div class="user-wrapper">
                        <div>
                            <small>Welcome Back :</small>
                            <h3>{ID_UserName}</h3>
                        </div>
                    </div>
                </header>
                <main>
                    <div class="headers-cards">
                        <div class="headers-card-single">
                            <div class="card-my-detail"> 
                                <h3 class="">ID : <span>{ID_}</span></h3>
                            </div>
                        </div>
                        <div class="headers-card-single">
                            <div class="card-my-detail"> 
                                <h3 class="">Wallet : <span class="scroll-bar">{Sub_Variable(address)}</span></h3>
                            </div>
                        </div>
                        <div class="headers-card-single">
                            <div class="card-link">      
                                <div class="my-link">
                                    <a href="#">{Ref_Link}</a>
                                </div>
                                <div class="link_copy"><button onClick={() => {Copy(Ref_Link, props.showAlert)}}>Copy link</button></div>
                            </div>
                        </div>
                        <div class="headers-card-single">
                            <div class="card-refresh"> 
                                <button onClick={() => {
                                    if (Is_State_Change === true) {
                                        SetIs_State_Change(false);
                                    }
                                    else if(Is_State_Change === false) {
                                        SetIs_State_Change(true);
                                    }
                                }}>Page Refresh<span></span></button>

                                <button onClick={() => {disconnect();}}>DisConnect<span></span></button>
                            </div>
                        </div>
                    </div>
                    
                    {/* <!-- Dashboard--Cards --> */}

                    <DashBoard_Form ReLoad={ReLoad} ID_={ID_} address={address} Is_State_Change={Is_State_Change} SetLoadingModal={props.SetLoadingModal} showAlert={props.showAlert}/>

                    {/* <!-- =====Roi--Activity+=== --> */}

                    <Roi_Income_Form ReLoad={ReLoad} ID_={ID_} ID_Type_={ID_Type_} address={address} Is_State_Change={Is_State_Change} SetLoadingModal={props.SetLoadingModal} showAlert={props.showAlert}/>

                    {/* <!-- =====Direct==Activity+=== --> */}

                    <Refferal_Income_Form ReLoad={ReLoad} ID_={ID_} address={address} Is_State_Change={Is_State_Change} SetLoadingModal={props.SetLoadingModal} showAlert={props.showAlert}/>

                    {/* <!-- =====Total==Activity+=== --> */}

                    {/* <div class="recent-grid">
                        <div class="projects">
                            <div class="card-table">
                                <div class="table-top">
                                    <span><h3>Total Activity</h3></span>
                                </div>
                                <div class="card-body scroll-bar">
                                    <div class="table-responsive">
                                        <table width="100%">
                                            <thead>
                                            <tr>
                                                <td>Sr.</td>
                                                <td>Total Roi Bonus</td>
                                                <td>Total Refferal Bonus</td>
                                                <td>Total Level Bonus</td>
                                                <td> Total Rewardss Bonus</td>
                                                <td>Total Earn</td>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td><span class="td-space">$</span>10</td>
                                                <td><span class="td-space">$</span>100</td>
                                                <td><span class="td-space">$</span>150</td>
                                                <td><span class="td-space">$</span>25</td>
                                                <td><span class="td-space">$</span>25</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="pre-next-btn">
                                    <button>&larr; Pre </button>
                                    <div class="show-rows">20/100</div>
                                    <button>Next &rarr; </button>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {/* <!--  -------Search--Tree--Section----------> */}
                    
                    <Team_Tree_Form ID_={ID_} address={address} Is_State_Change={Is_State_Change} SetLoadingModal={props.SetLoadingModal} showAlert={props.showAlert}/>

                </main>
            </div>  
        </> 
    );

    // return (
    //     <>
    //         <input type="checkbox" id="nav-toggle"/>
    //         <div class="sidebar">
    //             <div class="sidebar-brand">
    //                 <span>FXC PROFIT</span>
    //                 {/* <!-- <span><img src="./assets/logo.png" alt=""></span> --> */}
    //             </div>
    //             <div class="sidebar-menu">
    //                 <ul>
    //                     <li>
    //                         <a style={{cursor: "pointer"}} class="active" onClick={() => {SetCurrentForm("DASHBOARD");}}>
    //                             <span><img src={h_1} alt=""/></span>
    //                             <span>Dashboard</span>
    //                         </a>
    //                     </li>
    //                     <li>
    //                         <a style={{cursor: "pointer"}} onClick={() => {SetCurrentForm("ROI");}}>
    //                             <span><img src="" alt=""/>{/*&rarr;*/}</span>
    //                             {/* <!-- <span> &rarr; </span> --> */}
    //                             <span>Roi Bonus</span>
    //                         </a>
    //                     </li>
    //                     <li>
    //                         <a style={{cursor: "pointer"}} onClick={() => {SetCurrentForm("DIRECT");}}>
    //                             <span><img src="" alt=""/>{/*&rarr;*/}</span>
    //                             {/* <!-- <span> &rarr; </span> --> */}
    //                             <span>Direct Bonus</span>
    //                         </a>
    //                     </li>
    //                     <li>
    //                         <a style={{cursor: "pointer"}} onClick={() => {SetCurrentForm("LEVEL");}}>
    //                             <span><img src="" alt=""/>{/*&rarr;*/}</span>
    //                             {/* <!-- <span> &rarr; </span> --> */}
    //                             <span>Level Bonus</span>
    //                         </a>
    //                     </li>
    //                     <li>
    //                         <a style={{cursor: "pointer"}} onClick={() => {SetCurrentForm("REWARDS");}}>
    //                             <span><img src="" alt=""/>{/*&rarr;*/}</span>
    //                             {/* <!-- <span> &rarr; </span> --> */}
    //                             <span>Rewards Bonus</span>
    //                         </a>
    //                     </li>
    //                     <li>
    //                         <a style={{cursor: "pointer"}} onClick={() => {SetCurrentForm("TREE");}}>
    //                             <span><img src="" alt=""/>{/*&rarr;*/}</span>
    //                             {/* <!-- <span> &rarr; </span> --> */}
    //                             <span>Tree View</span>
    //                         </a>
    //                     </li>
    //                     <li>
    //                         <a style={{cursor: "pointer"}} class="active" onClick={() => {props.SetIsLogin(false)}}>
    //                             <span><img src={u_3} alt=""/></span>
    //                             <span>Disconnect</span>
    //                         </a>
    //                     </li>
    //                 </ul>
    //             </div>
    //         </div>

    //         <div class="main-content">
    //             <header>
    //                 <h3>
    //                     <label for="nav-toggle">
    //                         <span class="menu-image"><img src={menu1} alt=""/></span>
    //                     </label>
    //                 </h3>
    //                 <div class="user-wrapper">
    //                     <div>
    //                         <small>Welcome Back : </small>
    //                         <small>{ID_UserName}</small> {/*<h3></h3> */}
    //                         {/* <!-- <small> <link href="">Copy Reffer Link<img src="./assets/Pic.png" alt="" class="back-color"></link> </small> --> */}
    //                     </div>
    //                 </div>
    //             </header>
                
    //             <main>
    //                 {
    //                     CurrentForm === "DASHBOARD" ? (
    //                         <>                            
    //                             {/* <!-- Dashboard--Cards --> */}
    //                             <DashBoard_Form SetCurrentForm={SetCurrentForm} ID_={ID_} ID_Cur_Topup={ID_Cur_Topup} ID_Type_={ID_Type_} address={address} SetLoadingModal={props.SetLoadingModal} showAlert={props.showAlert}/>
    //                         </>
    //                     ) : CurrentForm === "ROI" ? (
    //                         <>
    //                             {/* <!-- =====Roi==Activity+=== --> */}
    //                             <Roi_Income_Form ID_={ID_} ID_Cur_Topup={ID_Cur_Topup} ID_Type_={ID_Type_} address={address} SetLoadingModal={props.SetLoadingModal} showAlert={props.showAlert}/>
    //                         </>
    //                     ) : CurrentForm === "DIRECT" ? (
    //                         <>
    //                             {/* <!-- =====Direct==Activity+=== --> */}
    //                             <Direct_Income_Form ID_={ID_} ID_Cur_Topup={ID_Cur_Topup} address={address}/>
    //                         </>
    //                     ) : CurrentForm === "LEVEL" ? (
    //                         <>
    //                             {/* <!-- =====Level==Activity+=== --> */}
    //                             <Level_Income_Form ID_={ID_} ID_Cur_Topup={ID_Cur_Topup} ID_Type_={ID_Type_} address={address} SetLoadingModal={props.SetLoadingModal} showAlert={props.showAlert}/>
    //                         </>
    //                     ) : CurrentForm === "REWARDS" ? (
    //                         <>
    //                             {/* <!-- =====Rewards==Activity+=== --> */}
    //                             <Rewards_Form ID_={ID_} ID_Cur_Topup={ID_Cur_Topup} ID_Type_={ID_Type_} address={address} SetLoadingModal={props.SetLoadingModal} showAlert={props.showAlert}/>
    //                         </>
    //                     ) : CurrentForm === "TREE" ? (
    //                         <>
    //                             {/* <!--  -------Search--Tree--Section----------> */}
    //                             <Team_Tree_Form ID_={ID_} ID_Cur_Topup={ID_Cur_Topup} address={address} showAlert={props.showAlert}/>
    //                         </>
    //                     ) : (
    //                         <></>
    //                     )
    //                 }                        
                     
    //             </main>
    //         </div>
    //     </>
    // );

}
